import { useEffect, useState } from 'react';
/**
 * Keeps track of an elements height, updating state when the ref changes.
 * @param ref ref of the HTML element to track the height of
 * @returns current height of ref element
 */
const useRefHeight = (ref) => {
    const [elementHeight, setElementHeight] = useState(0);
    useEffect(() => {
        if (ref.current) {
            const { current } = ref;
            const boundingRect = current.getBoundingClientRect();
            const { height } = boundingRect;
            setElementHeight(Math.round(height));
        }
    }, [ref]);
    return elementHeight;
};
export default useRefHeight;
